module.exports = __webpack_public_path__ + "static/media/Scope-7.39ad9c80.png";